import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

// componentes
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import { Link } from 'react-router-dom';
import ListaCheckbox from './../../../Componentes/ListaCheckbox';

// cria os parametros
function Parametros({
    parametros, 
    alterarParametros, 
    clicouCadastrar
}){

    // expande filtros
    let [mostrarMais, expandirParametros] = useState(false); 

    // parametros
    return <div className="parametros">
        <div className="parametros-inicial">
            <Button variant="padrao" className="botao-cadastrar" onClick={clicouCadastrar}>
                <FontAwesomeIcon className="icone" icon={["fas", "plus"]} />
                <span>Cadastrar Ip</span>
            </Button>
            <DebounceInput 
                placeholder="Consultar ip" 
                debounceTimeout={400}
                element={Form.Control} 
                value={parametros.texto}
                onChange={(e) =>{
                    alterarParametros({...parametros, texto: e.target.value, pagina: 1})
                }}
            />
            
        </div>

        {mostrarMais && 
            <Row className='mt-3'>
                <Col md='9'>

                </Col>
            </Row>
        }
    </div>

}

// importa states
let mapStateToProps = function(state){
    let estado = {
        login: state.login
    }
    return estado;
};

// retorna página de consulta
export default connect(mapStateToProps)(Parametros);